import { invariant } from '@e-socna/utils';

import { environment } from '../../../../environment';

import type {
  DocumentEditorState,
  HistorizedVersion,
} from '../../types/editor-state.type';
import type { Editable } from '../../types/editable.type';

export const createPushInPast =
  <E extends Editable>(currentPath: string) =>
  (state: DocumentEditorState<E>): readonly HistorizedVersion<E>[] => {
    const { documentEditorPastLength } = environment;

    if (documentEditorPastLength === -1) {
      return [
        ...state.pastVersions,
        {
          editable: state.editable,
          currentPath,
          currentVersion: state.currentVersion,
        },
      ];
    }

    invariant(
      !!documentEditorPastLength,
      'documentEditorPastLength cannot be 0',
    );

    const pastLengthMinusOne = documentEditorPastLength - 1;
    const minPastLength = Math.min(
      pastLengthMinusOne,
      state.pastVersions.length,
    );
    const pastVersions = state.pastVersions.slice(
      state.pastVersions.length - minPastLength,
      state.pastVersions.length,
    );

    return [
      ...pastVersions,
      {
        editable: state.editable,
        currentPath,
        currentVersion: state.currentVersion,
      },
    ];
  };
